<template>
<div class="start-container">
  <div id="start" :class="{ suggesting: search.length > 0 || (glass === true && search.length <= 0) }">
    <Hamburger />
    <div @click="glass = false" class="white-wash"></div>
    <div class="header"></div>
    <!--<h1>Reformbanken</h1>-->
    <div class="header-logo">
      <img src="../assets/img/Reformbanken-logo.svg" alt="logo">
    </div>
    <div class="counter-container">
      <div class="clock-wrapper">
        <div class="counter"></div>
      </div>
      <span class="flip-text">idéer som förbättrar samhället</span>
    </div>
    <form>
      <input v-model="search" type="search">
      <div class="cross" @click="search = ''"></div>
      <img
        @click="glass = !glass"
        src="../assets/img/search.svg"
        alt="Search"
        title="Search"
      />
      <span class="small">Vill du ha förslag på vad du kan söka efter?</span>
      <div class="suggestion-box" v-if="search.length > 2">
        <ul>
          <li
            @click="setArticle(article)"
            v-for="article in suggestions"
            :key="article.id"
          >
            <router-link :to="'/article/' + article.slug">
              {{article.title.rendered}}
            </router-link>
          </li>
          <li v-if="suggestions.length < 1">Inga resultat för '{{ search }}'</li>
        </ul>
      </div>
    </form>
    <Grid />
  </div>
</div>
</template>

<script>
import Grid from './Grid'
import Hamburger from './Hamburger'
import 'flipclock-es6'

export default {
  name: 'Start',
  data () {
    return {
      search: '',
      glass: false
    }
  },
  props: [],
  computed: {
    pages () {
      return this.$store.state.pages
    },
    suggestions () {
      return this.$store.state.searchResult
    },
    tagLength () {
      return this.$store.state.currentTags
    },
    counter () {
      return this.$store.state.posts.length
    }
  },
  watch: {
    search () {
      if (this.search.length > 1) {
        this.$store.dispatch('getClearTags')
      }
      this.$store.dispatch('getSearch', this.search)
      this.glass = false
    },
    glass () {
      if (this.glass === true) {
        var searchInput = document.getElementsByTagName('input')[0]
        searchInput.focus()
      }
    }
  },
  beforeMount () {
    this.$store.dispatch('getTags')
  },
  methods: {
    setArticle (article) {
      this.$store.dispatch('getArticle', article)
    }
  },
  mounted () {
    let self = this
    var clock = window.$('.counter').FlipClock('00', {
      clockFace: 'Counter'
    })
    window.counter = window.setInterval(function () {
      clock.increment()
      if (clock.getTime().time === self.counter) {
        window.clearInterval(window.counter)
      }
    }, 200)
  },
  beforeDestroy () {
    window.counter = 0
    window.clearInterval(window.counter)
  },
  components: { Grid, Hamburger }
}
</script>

<style>
body {
  overflow-x: hidden;
}
</style>
<style lang="scss" scoped>
.start-container {
  display: block;
  max-width: 650px;
  margin: auto;
  padding: 0 10px;
  color: $black;
}
#start {
  margin: 0 auto;
  .header {
    width: 100vw;
    height: 50vw;
    background-image: url('../assets/img/triangle-header.svg');
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center top;
    position: absolute;
    top: 0;
    right:0;
    z-index: -9;
  }
  .white-wash {
    background-color: #fff;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    position: fixed;
    opacity: 0;
    height: 0px;
    transition: opacity 0.4s ease;
  }
  .header-logo {
    padding-top: 25vh;
    img {
      width: 100%;
      height: auto;
    }
    width: calc(100% - 20px);
    margin: auto;
    padding-bottom: 2px;
  }
  h1 {
    font-size: 91px;
    font-weight: 900;
    font-style: normal;
    font-family: 'Playfair Display';
    background: -webkit-linear-gradient(45deg, #7F0E56, #CB1988);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-top: 20vh;
  }
  .opacity {
    opacity:0;
  }
  .counter-container {
    display: flex;
    flex-direction: row;
    width:100%;
    align-items: center;
    justify-content: center;
    .clock-wrapper {
      -moz-margin-start: -20px;
    }
  }
  .counter {
    zoom: 0.4;
    -moz-transform: scale(0.4);
    // width:10%;
    margin:0;
  }
  .flip-text {
    min-width:380px;
    text-align: left;
    font-size: 26px;
    line-height: 40px;
    font-family: 'Playfair Display';
    font-weight: 900;
    font-style: italic;
    -webkit-margin-start: 10px;
    -moz-margin-start: -30px;
  }
  .text-container {
    display: flex;
    align-items: center;
  }
  form {
    width: 100%;
    position: relative;
    z-index: 1;
    margin-top: 5vw;
    transition: all 0.2s ease;
    img {
      position: absolute;
      right: 12px;
      top: 3px;
      cursor: pointer;
      transition: all 0.1s ease-in;
      &:hover {
        transform: scale(0.95);
      }
    }
    .suggestion-box {
      position: absolute;
      background: $purple;
      color: white;
      width: 100%;
      top: 77px;
      font-size: 20px;
      font-family: 'Playfair Display';
      transitions: all 0.3s ease;
    }
    ul {
      transition: all 0.3s ease;
    }
    .suggestion-box li {
      list-style-type: none;
      position: relative;
      &:after {
        content: ' ';
        position: absolute;
        left: 16px;
        top: 22px;
        width: 6px;
        height: 6px;
        background-color: #fff;
      }
      text-align: left;
      padding: 15px;
      padding-bottom: 10px;
      padding-left: 34px;
      font-weight: 600;
      transition: all 0.2s ease;
      a {
        color: inherit;
        text-decoration: inherit;
        width: 100%;
        display: block;
      }
      &:last-child {
        padding-bottom: 15px;
      }
      &:hover {
        padding-left: 38px;
      }
    }
    input {
      width: 100%;
      border: 0;
      border-bottom: 3px solid $purple;
      font-size: 35px;
      padding: 5px 0;
      background-color: transparent;
      margin-bottom: 10px;
      text-align: left;
      font-weight: 900;
      font-family: "Playfair Display";
      color: $purple;
      transition: all 0.3s ease;
      -webkit-appearance: none;
      -webkit-border-radius: 0;
      border-radius: 0;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    input[type="search"]::-webkit-search-cancel-button {
      -webkit-appearance: none;
      -webkit-appearance: textfield;
       -webkit-border-radius: 0;
      border-radius: 0;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    input[type="search"]::-ms-clear {
      display: none;
    }
    input:focus, input:active {
      -webkit-border-radius: 0;
      border-radius: 0;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    .small {
      color: $mediumGrey;
      font-size: 12px;
      margin-bottom: 10px;
    }
  }
  .cross {
    display: none;
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 22px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    &:before {
      content: ' ';
      width: 36px;
      height: 5px;
      position: absolute;
      left: 0px;
      top: 15px;
      transform: rotate(-45deg);
      background-color: $black;
    }
    &:after {
      content: ' ';
      width: 36px;
      height: 5px;
      position: absolute;
      left: 0px;
      top: 15px;
      transform: rotate(45deg);
      background-color: $black;
    }
    &:hover {
      transform: scale(0.95);
    }
  }
  &.suggesting {
    .cross {
      display: block;
    }
    .white-wash {
      height: 100%;
      opacity: 0.8;
      z-index: 9999;
    }
    form {
      z-index: 9999999;
      transform: translateY(-7px);
      img {
        display: none;
      }
      input {
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.12);
        padding: 18px 10px 12px 20px;
        color: $black;
      }
      ul {

      }
    }
  }
  p, h5, .text-container {
    width: 100%;
    text-align: left;
  }
  h5.playfair-italic {
    margin-top:40px;
  }
}
@media #{$ipads} {
  #start .header-logo {
    padding-top: 25vh;
  }
  #start {
    h5:first-of-type {
      font-size: 3vw;
    }
    form {
      width: 100%;
    }
  }
  .clock-wrapper {
    margin-left: -10px;
  }
}
@media #{$small-pads} {
  #start form, #start h5, #start h1 {
    width: 100%;
  }
  #start {
    .header {
      background-size: auto 100%;
    }
    .counter-container > .clock-wrapper {
      -moz-transform: scale(0.4);
      -moz-margin-end: -40px;
      -moz-margin-start: -50px;
    }
    form  {
      width: 100%;
    }
    h1 {
      font-size: 12vw;
    }
    h5:first-of-type {
      font-size: 5vw;
    }
  }
    #start .flip-text {
      font-size: 16px;
    min-width:auto;
  }
  #start .counter {
    width:auto;
    margin-right: 6px;
    transform: scale(0.8);
    display: flex;
  }
  #start .counter-container {
    flex-direction: row;
    align-items: center;
    justify-content:center;
    margin-top:10px;
  }
  #start .flip-text {
    text-align:center;
    margin:0;
    padding:0;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
/* IE10+ CSS styles go here */
  .clock-wrapper {
    height: 40px;
    width: 140px;
    margin-right: -75px;
  }
  #start .counter-container .counter {
    width: auto;
    display: flex;
  }
}
@-moz-document url-prefix() {
    #start > .counter-container > .clock-wrapper {
      margin: -30px 0px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Start.vue